import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";

import CheckboxButton from "components/CheckboxButton";
import CheckboxButtonInput from "components/CheckboxButtonInput";

@translate()
export default class Questions extends Component {

  render() {
    const { questions, onChange, isDisabled } = this.props;
    return (
      <div>
        {questions.length > 0 && (
          <Fragment>
            <div>
              {questions &&
              Object.keys(questions).map((index) => {
                let id = "answer_"+questions[index].id;
                if (questions[index].typeAnswer === 'bool') {
                  return (
                    <CheckboxButton
                      key={index}
                      name={id}
                      isDisabled={isDisabled}
                      onChange={onChange}
                      value={questions[index].question}
                      label={questions[index].question}/>
                  );
                } else if (questions[index].typeAnswer === 'text') {
                  return (
                    <CheckboxButtonInput
                      key={index}
                      name={id}
                      type="text"
                      value={questions[index].question}
                      label={questions[index].question}
                      onChange={onChange}
                      isDisabled={isDisabled} />
                  );
                }
                return null;
              })}
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

Questions.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  questions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  rootClassname: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Cgn/Questions/index.js